// StickyTableContainer.js
import React, { useRef } from 'react';
import { TableContainer, Paper, Table } from '@mui/material';
import useAvailableHeight from '../utils/useAvailableHeight';

const StickyTableContainer = ({
    children,
    height,
    bottomSpacing = 20,
    tableProps = {},
    containerSx = {}
}) => {
    const containerRef = useRef(null);
    const maxHeight = useAvailableHeight(containerRef, bottomSpacing);

    return (
        <div ref={containerRef}>
            <TableContainer
                component={Paper}
                sx={{ height: height, maxHeight: `${maxHeight < height ? height : maxHeight}px`, overflowY: 'auto', ...containerSx }}
            >
                <Table stickyHeader {...tableProps}>
                    {children}
                </Table>
            </TableContainer>
        </div>
    );
};

export default StickyTableContainer;
